import { useContext, useMemo } from 'react'

import { createApiService } from '@core/api'
import { ServiceApiContext } from '@core/api/context/serviceApi'
import type { IAnyWidgetParams } from '@core/types'
import { defaultApiHost } from '@src/helpers'

/** @returns the service API object from the context. */
export function useApi() {
  const api = useContext(ServiceApiContext)
  if (!api) {
    throw new Error('Service API is not set in the context')
  }
  return api
}

/**
 * Use this hook if the service api is not provided from the context.
 * @returns the memoized service API object.
 */
export function useApiWithParams(params?: IAnyWidgetParams) {
  const api = useMemo(
    () =>
      createApiService({
        apiHost: params?.api_host ?? defaultApiHost,
        apiCache: params?.api_cache,
        apiCacheNonce: params?.api_cache_nonce,
        apiCacheHost: params?.api_cache_host,
      }),
    [
      params?.api_host,
      params?.api_cache,
      params?.api_cache_nonce,
      params?.api_cache_host,
    ],
  )
  return api
}
